// extracted by mini-css-extract-plugin
export default {"mobileNavigation":"mobileNavigation_mobileNavigation__01vsK","header":"mobileNavigation_header__+HcDY"};